<template>
<div class="uploadBox2">
    <h3>{{headerMessage}}</h3>
    <form role="form" enctype="multipart/form-data" @submit.prevent="onSubmit">
        <v-alert dismissible v-if="successMsg !== ''" type="success" color="green darken-4">
            <h5>OPERACIÓN EXITOSA!!</h5><span v-html="successMsg"></span>
        </v-alert>
        <v-alert dismissible v-if="errorMsg !== ''" type="error" color="red darken-4" >
            <h5>OPERACIÓN NO PERMITIDA!!</h5><span v-html="errorMsg"></span>
            <br>
            <exportar-excel :data="errores_excel" :exportFields="{'Archivo': 'archivo', 'Error': 'error'}" name="ErroresInformesTXT.xlsx">
                <v-btn color="green" x-small title="Descargar Información" v-tippy>
                Descargar Errores
                </v-btn>
            </exportar-excel>
        </v-alert>

        <div class="uploadBox2Main" v-if="!itemsAdded">
            <div class="form-group">
                <div class="dropArea" @ondragover="onChange" :class="dragging ? 'dropAreaDragging' : ''" @dragenter="dragging=true" @dragend="dragging=false" @dragleave="dragging=false">
                    <h5>{{dropAreaPrimaryMessage}}</h5>
                    <input type="file" id="items" name="items[]" required multiple @change="onChange" accept=".txt">
                    <p class="help-block">{{dropAreaSecondaryMessage}}</p>
                </div>
            </div>
        </div>
        <div class="uploadBox2Main" v-else>
            <div class="text-center">
                <v-container class="pa-1">
                    <v-row>
                        <v-col v-for="(name, x) in itemsNames" :key="'f'+x" cols="4" md="4">
                            <v-card  variant="tonal" min-width="300" max-width="300" max-height="350" class="pa-1">
                                <v-card-title class="primary white--text pa-0 justify-center align-center" >
                                <span style="font-size:12px"><strong>{{name.substring(0, 30)}}</strong></span>

                                </v-card-title>
                                <v-card-actions class="pa-1" style="position:relative; margin-top:-28px;">

                                <v-btn x-small icon color="white" title="Vista Previa" v-tippy @click.native="vista(name, itemsContenido[x] )">
                                    <v-icon>search</v-icon>
                                </v-btn>

                                <v-spacer></v-spacer>
                                <v-btn x-small icon color="red" @click.native="eliminar(x)" title="Eliminar" v-tippy>
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                </v-card-actions>
                                <v-card-text class="pa-1">
                                    <table v-if="itemsContenido[x] != undefined" class="pa-0" style="font-size:12px; width:100%; border: 1px double #a94442;">
                                    <tr class="pa-0" >
                                    <td class="pa-0 pl-1" style="text-align:left; line-height: 120%; ">
                                    Tipo de Informe:<b style="color:navy;"> {{ nombreTipoDocumento(itemsContenido[x].split(/\r\n|\n/)[0].split('|')[0]) }}</b><br/>
                                    Ejercicio:<b style="color:navy;"> {{ itemsContenido[x].split(/\r\n|\n/)[0].split('|')[2] }}</b><br/>
                                    Destino Aduanero:<b style="color:navy;"> {{ nombreDestinoAduanero(itemsContenido[x].split(/\r\n|\n/)[0].split('|')[1]) }}</b><br/>
                                    Periodo:<b style="color:navy;"> {{ nombrePeriodo(itemsContenido[x].split(/\r\n|\n/)[0].split('|')[3]) }}</b>
                                    </td>
                                    </tr>

                                    </table>

                                    <div class="global">
                                        <div class="contenido">
                                            <span class="text-left">
                                                <p style="word-wrap: break-word;"><small>{{itemsContenido[x]}}</small></p>
                                            </span>
                                        </div>
                                    </div>
                                </v-card-text>

                            </v-card>
                        </v-col>
                    </v-row>
                    <v-dialog v-model="dialog" width="500">

                        <v-card>
                            <v-card-title class="text-h5 grey lighten-2">
                                {{titulo}}
                            </v-card-title>

                            <v-card-text>
                                <div class="vista">
                                    <div class="contenido">
                                        <span class="text-left">
                                            <p v-if="postURL!='guardar_informe_descargo'" style="word-wrap: break-all;"><small>{{contenido}}</small></p>
                                            <p v-if="postURL=='guardar_informe_descargo'">
                                                <pre><small>{{contenido}}</small></pre>
                                            </p>
                                        </span>
                                    </div>
                                </div>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="dialog = false">
                                    CERRAR
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-container>

            </div>

            <div class="loader" v-if="isLoaderVisible">
                <div class="loaderImg"></div>
            </div>
        </div>
        <div>

            <v-card-actions>
                <v-btn @click.native="modal=false; removeItems();">
                    <v-icon>cancel</v-icon> Limpiar
                </v-btn>
                <v-spacer></v-spacer>

                <v-col v-if="planta_referencia" cols="12" sm="6" md="3">
                    <v-autocomplete v-model="planta" label="Planta Referencia" return-object :items="plantas" :hide-no-data="true" item-text="referencia" item-value="referencia" clearable>

                    </v-autocomplete>

                </v-col>
                <v-col v-if="planta_referencia" cols="2" sm="2" md="2">
                    <v-checkbox v-if="planta !=null " v-model="consolidar" label="No Consolidar"></v-checkbox>
                </v-col>

                <v-btn color="success" :disabled="itemsAdded < minItems || itemsAdded > maxItems" @click.native="guardar();">
                    <v-icon>done</v-icon> Cargar
                </v-btn>
            </v-card-actions>

        </div>

    </form>
  
</div>
</template>

<script>
require('es6-promise').polyfill();
import axios from 'axios';
import JSZip from 'jszip';

component: {
    axios
}
export default {
    props: {
        postURL: {
            type: String,
            required: true
        },
        minItems: {
            type: Number,
            default: 1
        },
        maxItems: {
            type: Number,
            default: 30
        },
        method: {
            type: String,
            default: 'post'
        },
        postMeta: {
            type: [String, Array, Object],
            default: ''
        },
        postData: {
            type: [Object],
            default: () => {}
        },
        postHeader: {
            type: [Object],
            default: () => {}
        },
        successMessagePath: {
            type: String,
            required: true
        },
        errorMessagePath: {
            type: String,
            required: true
        },
        headerMessage: {
            type: String,
            default: 'Agregar Archivos'
        },
        dropAreaPrimaryMessage: {
            type: String,
            default: 'Arrastre Archivos Aqui..'
        },
        dropAreaSecondaryMessage: {
            type: String,
            default: 'o de click para selecionar..'
        },
        fileNameMessage: {
            type: String,
            default: 'Nombre'
        },
        fileSizeMessage: {
            type: String,
            default: 'Tamaños'
        },
        totalFileMessage: {
            type: String,
            default: 'Total Archivos:'
        },
        totalUploadSizeMessage: {
            type: String,
            default: 'Total tamaño:'
        },
        removeFileMessage: {
            type: String,
            default: 'Limpiar'
        },
        uploadButtonMessage: {
            type: String,
            default: 'Guardar'
        },
        cancelButtonMessage: {
            type: String,
            default: 'Cancelar'
        },
        fileUploadErrorMessage: {
            type: String,
            default: 'Ocurrio un error'
        },
        minFilesErrorMessage: {
            type: String,
            default: 'Minimum files that need to be added to uploader'
        },
        maxFilesErrorMessage: {
            type: String,
            default: 'Maximo número de archivos'
        },
        retryErrorMessage: {
            type: String,
            default: 'Favor de intentar nuevamente'
        },
        httpMethodErrorMessage: {
            type: String,
            default: "No fue posible enviar los archivos verifique su conexión"
        },
        showHttpMessages: {
            type: Boolean,
            default: true
        }
    },

    /*
     * The component's data.
     */
    data() {
        return {
            archivos_tmp:[],
            name_del: "",
            consolidar:false,
            elzip: "",
            errores_excel:[],
            periodos:[],
            tipos_documento:[],
            destinos_aduaneros:[],
            dragging: false,
            plantas: [],
            planta: null,
            items: [],
            itemsAdded: '',
            itemsNames: [],
            itemsSizes: [],
            itemsContenido: [],
            itemsTotalSize: '',
            formData: '',
            successMsg: '',
            errorMsg: '',
            isLoaderVisible: false,
            dialog: false,
            titulo: '',
            contenido: '',
        }
    },
    created: function () {
        this.cargarPlantas();
        this.getPeriodos();
    },
    computed: {

        planta_referencia() {
            return  this.$local_storage.get("Modulo16") == 100 ;
        },


    },
    methods: {
        // http://scratch99.com/web-development/javascript/convert-bytes-to-mb-kb/
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                resolve(reader.result);
                };

                reader.onerror = () => {
                reject(reader.error);
                };

                reader.readAsArrayBuffer(file);
            });
            },
        bytesToSize(bytes) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes === 0) return 'n/a';
            let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            if (i === 0) return bytes + ' ' + sizes[i];
            return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
        },
        vista(t, c) {
            this.titulo = t;
            this.contenido = c;
            this.dialog = true;

        },
        nombrePeriodo(periodo){
            let p = this.periodos.filter(item => {
                            return item.clave == periodo
                        });
            if (p.length > 0) {
                return  p[0].nombre;
            }else{
                return "Desconocido";
            }
        },
        getPeriodos: function () {

            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 32
                })
                .then(response => {

                    this.periodos = response.data;
                    this.getTiposDocumento();
                    this.getDestinosAduaneros();

                })
                .catch(error => {

                });
            },
        nombreTipoDocumento(tipo){
            let p = this.tipos_documento.filter(item => {
                            return item.clave == tipo
                        });
            if (p.length > 0) {
                return  p[0].nombre;
            }else{
                return "Desconocido";
            }
        },
        getTiposDocumento: function () {

            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 31
                })
                .then(response => {
                    this.tipos_documento = response.data;
                })
                .catch(error => {

                });
            },
        nombreDestinoAduanero(destino){
            let p = this.destinos_aduaneros.filter(item => {
                            return item.clave == destino
                        });
            if (p.length > 0) {
                return  p[0].nombre;
            }else{
                return "Desconocido";
            }
        },
        getDestinosAduaneros: function () {

            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 30
                })
                .then(response => {
                    this.destinos_aduaneros = response.data;
                })
                .catch(error => {

                });
        },
       async onChange(e) {
            let self = this;
            self.$root.$dialogLoader.show("Espere un momento por favor...");
            this.removeItems();
            this.successMsg = '';
            this.errorMsg = '';
            this.formData = new FormData();
            let files = e.target.files || e.dataTransfer.files;
            this.itemsAdded = files.length;
            let fileSizes = 0;

            self.errorMsg = "";
            let j = 0;
            for (let x in files) {
                
                if (!isNaN(x) && files[x].type == "text/plain") {
                    let reader = new FileReader()
                    reader.readAsText(files[x]);

                    self.items = e.target.files[x] || e.dataTransfer.files[x];

                    self.itemsNames.push(files[x].name);
                    self.itemsSizes.push(self.bytesToSize(files[x].size));
                    fileSizes += files[x].size;
                    self.formData.append('items[]', self.items);


                    reader.onload = (e) => {

                        if (e.target.result.split(/\r\n|\n/)[0].split('|')[0] == '02'){
                            self.itemsContenido.push(e.target.result);

                        }else{
                            self.errorMsg += " * Archivo no valido " + files[x].name + "<br/>";
                            self.itemsContenido.push("CONTENIDO NO VALIDO");

                        }


                    }

                    self.archivos_tmp.push({
                        "id": files[x].name,
                        "file": files[x]
                    });


                } else {
                    if (!isNaN(x))
                        self.errorMsg += " * Archivo no valido " + files[x].name + "<br/>";
                }
            }
            this.itemsTotalSize = this.bytesToSize(fileSizes);
            this.itemsAdded = this.itemsNames.length;


            /*const filesArray = Array.from(files);

            const zip = new JSZip();

            for (let i = 0; i < filesArray.length; i++) {
                const file = filesArray[i];
                const fileContent = await self.readFileAsync(file); // Función para leer el contenido del archivo

                zip.file(file.name, fileContent);
            }

            zip.generateAsync({ type: 'blob' })
                .then(content => {
                // Aquí puedes hacer algo con el archivo zip generado, como descargarlo
                   self.elzip = content;
            });*/

            self.$root.$dialogLoader.hide();
        },

        removeItems() {
            this.items = '';
            this.itemsAdded = '';
            this.itemsNames = [];
            this.itemsSizes = [];
            this.itemsContenido = [];
            this.itemsTotalSize = '';
            this.dragging = false;
            this.errorMsg = "";
            this.archivos_tmp = [];
        },
        eliminar(index) {
            this.name_del =  this.itemsNames[index];
            this.itemsNames.splice(index, 1);
            this.itemsSizes.splice(index, 1);
            this.itemsContenido.splice(index, 1);
            delete this.items[index]
            this.itemsAdded = this.itemsAdded - 1;
            this.formData.append('items[]', this.items);
            this.successMsg = "";
            this.errorMsg = "";

            this.archivos_tmp = this.archivos_tmp.filter(x => x.id != this.name_del);
            /*var jszip = new JSZip( this.elzip);
            jszip.remove(this.name_del);*/
            
        },

        async guardar() {
            var self = this;
            self.errorMsg = "";
            self.successMsg = "";
            var rfcActual = this.$local_storage.get("rfc").toString().trim().toUpperCase();

            self.$root.$dialogLoader.show("Espere un momento por favor...");
            var files = [];
            for (let x in self.archivos_tmp) {
                files.push(self.archivos_tmp[x].file);
            }

            const filesArray = Array.from(files);

            const zip = new JSZip();

            for (let i = 0; i < filesArray.length; i++) {
                const file = filesArray[i];
                const fileContent = await self.readFileAsync(file); // Función para leer el contenido del archivo

                zip.file(file.name, fileContent);
            }

            zip.generateAsync({ type: 'blob' })
                .then(content => {
                // Aquí puedes hacer algo con el archivo zip generado, como descargarlo
                   self.elzip = content;
            });


            const name = rfcActual + Math.ceil(Math.random()*1000000) + '.zip'
                var keyBucket = rfcActual + "/soluciona31/cargados/" + name;
                var datos = {
                    key: keyBucket,
                    bucket: "production.econnect.ds",
                    type: self.elzip.type
                }

                await axios.post(self.$hostname + 's3/upload_url/', datos)
                    .then(async  (res) => {

                        if (typeof res.data !== 'undefined') {
                            var urlput = res.data.mensaje;

                             await  axios.put(urlput, self.elzip, {
                                    headers: {
                                        'Content-Type': self.elzip.type
                                    }
                                })
                                .then(async (res) => {

                                    let formData = {};

                                    if (self.planta != null && self.planta.referencia != null) {
                                        if(self.consolidar == true){
                                            formData = { key: keyBucket, rfc: rfcActual, usuario: self.$local_storage.get("email"),   rfc_original: self.planta.rfc  };
                                        }else{
                                            formData = { key: keyBucket, rfc: rfcActual, usuario: self.$local_storage.get("email"),  planta: self.planta.referencia  };
                                        }

                                    }else{
                                        formData = {  key: keyBucket,  rfc: rfcActual, usuario: self.$local_storage.get("email")  };
                                    }

                                    await axios.post(self.$apiSA31 + 'soluciona31/' + self.postURL + '/', formData)
                                        .then((res) => {
                                          console.log(res);
                                          var respuesta = res.data;
                                            respuesta.forEach(x => {
                                                if(x.error == undefined){
                                                    self.successMsg += '<li>' + x.archivo + ' ' + x.mensaje +'</li>';
                                                }else{
                                                    self.errorMsg += '<li>' + x.archivo  + '  ' + x.error +  ' </li>';
                                                    self.errores_excel.push({'archivo':  x.archivo, "error": x.error});
                                                }

                                            })

                                            self.items = '';
                                            self.itemsAdded = '';
                                            self.itemsNames = [];
                                            self.itemsSizes = [];
                                            self.itemsContenido = [];
                                            self.itemsTotalSize = '';
                                            self.dragging = false;
                                            self.$root.$dialogLoader.hide();
                                        }).catch((error) => { //ya que si el archivo es muy grande recibirá un timeOut, igualmente recibirá notificación al terminar de cargarse
                                            var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                                            self.errorMsg += mensaje;
                                            self.$root.$dialogLoader.hide();

                                        });
                                }).catch((error) => {

                                    self.$root.$dialogLoader.hide();
                                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                                    self.errorMsg += mensaje;



                                });
                            self.$root.$dialogLoader.hide();
                        } else {

                            self.$root.$dialogLoader.hide();
                            var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                            self.errorMsg += mensaje;
                        //    self.errores_excel.push({'archivo': x[1].name, "error": mensaje});



                        }
                    }).catch((error) => {

                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        self.errorMsg += mensaje;
                    //    self.errores_excel.push({'archivo': x[1].name, "error": mensaje});
                        self.$root.$dialogLoader.hide();

                    });



            //self.removeItems();


            //console.log("Intento:",intento);

        },
        cargarPlantas: function () {

            let data = {
                cliente: this.$local_storage.get("id_cliente"),
            };
            axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.plantas = res.data;

                    }
                })
                .catch(err => {
                    console.log();
                });
        },
    }
}
</script>

<style>
.uploadBox2 {
    position: relative;
    background: #eeeeeeee;
    padding: 0 1em 1em 1em;
    margin: 1em;
}

.uploadBox2 h3 {
    padding-top: 1em;
}

.uploadBox2 .uploadBox2Main {
    position: relative;
    margin-bottom: 1em;
    margin-right: 1em;
}

/* Drag and drop */
.uploadBox2 .dropArea {
    position: relative;
    width: 100%;
    height: 300px;
    border: 5px dashed #0E4D78;
    text-align: center;
    font-size: 2em;
    padding-top: 80px;
}

.uploadBox2 .dropArea input {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

/* End drag and drop */

/* Loader */
.uploadBox2 .loader {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    opacity: 0.9;
}

.uploadBox2 .loaderImg {
    border: 9px solid #eee;
    border-top: 9px solid #00ADCE;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* End Loader */

.uploadBox2 .errorMsg {
    font-size: 2em;
    color: #a94442;
}

.uploadBox2 .successMsg {
    font-size: 2em;
    color: #3c763d;
}
</style>
<style scoped>
.global {
    margin-left: 0px;
    margin-top: 3px;
    height: 152px;
    width: auto;
    border: 1px solid #a94442;
    background: #f1f1f1;
    overflow-y: scroll;
    color: blue;

}

.vista {
    margin-left: 0px;
    margin-top: 3px;
    height: 400px;
    width: auto;
    border: 1px solid #ddd;
    background: #FFF;
    overflow-y: scroll;
    color: blue;
}

.contenido {
    padding: 5px;
    height: auto;

}

</style>
